import styled from 'styled-components';
import { ReactComponent as TrashIcon } from 'Images/icon-action-bar-trash.svg';
import colors from 'Styles/colors';

const Trash = styled(TrashIcon).attrs({
  id: 'qa-delete-ws'
})`
    height: 17px;
    g > path {
      fill: ${colors.red1} !important;
    }
  `;

Trash.displayName = 'Trash';
export default Trash;
